<!-- Auth Container -->
<div class="prep-auth" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center stretch">

  <main [@fadeInUp] id="main-content" class="card" fxFlex="45" fxFlex.lt-md="100" fxLayoutAlign="start stretch"
    fxLayout="column" role="main" [attr.aria-label]="LangTextData?.ariaLabels.main">

    <form class="auth-form" [formGroup]="UserLoginFormGroup" (ngSubmit)="send()" fxLayout="column">
      <!-- Header-->
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <!-- Logo + APP Name-->
        <div fxFlex="70" fxFlex.sm="60" fxFlex.xs="50">
          <div fxLayoutAlign="start center">
            <img src="../../../../assets/splash-screen/prep-white-icon.svg"
              [attr.alt]="LangTextData?.altLabels.prepLogo" class="auth-form-logo" />
            <h1 class="prep-heading">
              {{ LangTextData?.htmlLabel.appName }}
            </h1>
          </div>
        </div>
        <!-- MULTI - LANG -->
        <div fxFlex="30" fxFlex.sm="40" fxFlex.xs="50" fxLayoutAlign="end center">
          <prep-language-selector></prep-language-selector>
        </div>
      </div>
      <!-- Titles -->
      <div fxLayout="row">
        <div fxFlex="100" style="padding-top: 25px;">
          <h2 *ngIf="SSOFlow" style="font-size: 34px;">
            {{ LangTextData?.htmlLabel.ssoUserLogin }}
          </h2>
          <h2 *ngIf="!SSOFlow" style="font-size: 34px;">{{ LangTextData?.htmlLabel.userLogin }}</h2>
          <h3 style="color: #136EE9; font-size: 18px; font-weight: bold">
            {{ LangTextData?.htmlLabel.appWelcome }}
          </h3>
        </div>
      </div>
      <!-- Input Fields -->
      <div fxLayout="row" style="padding-top: 15px;padding-bottom:25px;">
        <div *ngIf="!SSOFlow" fxFlex="auto" fxLayout="column">
          <small>{{ LangTextData?.htmlLabel.requiredFieldMessage }}</small>

          <!-- Email -->
          <mat-form-field fxFlex="grow" appearance="outline">
            <mat-label>{{ LangTextData?.htmlLabel.email }}</mat-label>
            <input matInput #emailInputRef required formControlName="username" id="username" />
          </mat-form-field>

          <!-- Password -->
          <mat-form-field fxFlex="grow" appearance="outline" style="margin-top: 7px">
            <mat-label>{{ LangTextData?.htmlLabel.password }}</mat-label>
            <input matInput [type]="inputType" formControlName="password" id="password" required minlength="6" />

            <!-- Show/Hide Button -->
            <button type="button" mat-icon-button matSuffix (click)="toggleVisibility()" [attr.aria-label]="
              visible
                ? LangTextData?.ariaLabels.passwordVisibilityToggle.true
                : LangTextData?.ariaLabels.passwordVisibilityToggle.false
            " [attr.aria-pressed]="visible" [matTooltip]="
              LangTextData?.tooltipLabels.buttonPasswordToggle
            ">
              <mat-icon *ngIf="visible">visibility</mat-icon>
              <mat-icon *ngIf="!visible">visibility_off</mat-icon>
            </button>

            <mat-hint style="color: black; margin-top: 15px">{{
              LangTextData?.htmlLabel.passwordHint
              }}</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <!-- Remember Me & Forgot Password -->
      <div *ngIf="!SSOFlow" fxLayout="row">
        <div fxFlex="100" [attr.aria-label]="LangTextData?.ariaLabels.loginPreferences"
          fxLayoutAlign="space-between center" style="padding: 10px 0px;">
          <mat-checkbox class="caption" [attr.aria-label]="LangTextData?.ariaLabels.rememberMe">
            {{ LangTextData?.htmlLabel.rememberMe }}
          </mat-checkbox>
          <a [routerLink]="['/forgot-password']" class="caption"
            [attr.aria-label]="LangTextData?.ariaLabels.forgotPassword">
            {{ LangTextData?.htmlLabel.forgotPassword }}
          </a>
        </div>
      </div>
      <!-- Sign In Button -->
      <div fxLayout="row" style="padding-top: 15px;padding-bottom:25px;">
        <div fxFlex="100">
          <button mat-raised-button color="primary" class="platform-login-button" type="submit" id="submit"
            [disabled]="UserLoginFormGroup.invalid || is_loading" aria-label="Sign in"
            [attr.aria-disabled]="UserLoginFormGroup.invalid || is_loading" [attr.aria-busy]="is_loading">
            <ng-container *ngIf="!is_loading; else loading">
              {{ LangTextData?.htmlLabel.signIn }}
            </ng-container>
            <ng-template #loading>
              {{ LangTextData?.htmlLabel.signInLoading }}
            </ng-template>
          </button>
        </div>
      </div>
      <!-- Privacy Policy -->
      <div fxLayout="row">
        <div fxFlex="100">
          <div class="privacy-note" role="note" style="text-align: center; margin-top: 10px"
            [attr.aria-label]="LangTextData?.ariaLabels.privacyNote">
            <p>
              {{ LangTextData?.htmlLabel.privacyPolicyHint }}<br />
              <a href="https://prep.continualengine.com/privacy-policy/" target="_blank" role="link"
                [attr.aria-label]="LangTextData?.ariaLabels.privacyPolicyLink">
                {{ LangTextData?.htmlLabel.privacyPolicy }}
              </a>
            </p>
          </div>
        </div>
      </div>
      <!-- Spinner -->
      <div fxLayout="row">
        <div fxFlex="100">
          <div *ngIf="is_loading" fxLayout="row" fxLayoutAlign="center center" role="status" aria-live="polite"
            [attr.aria-busy]="is_loading" style="padding: 15px 0">
            <mat-spinner color="primary" [diameter]="40"
              [attr.aria-label]="LangTextData?.ariaLabels.loadingSpinner"></mat-spinner>
            <span class="cdk-visually-hidden">{{
              LangTextData?.ariaLabels.spinnerText
              }}</span>
          </div>
        </div>
      </div>
      <!-- Powered By -->
      <div fxLayout="row" fxLayoutAlign="center center" style="width: 100%;">
        <div style="text-align: center;">
          <span>{{ LangTextData?.htmlLabel.poweredBy }}</span><br />
          <img src="../../../../assets/Logo/ce-logo.svg" [attr.alt]="LangTextData?.altLabels.continualEngineLogo"
            height="50" />
        </div>
      </div>
    </form>
  </main>
</div>